import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationState } from '@mews-commander/types';
import { withScopeContext } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { notEmpty } from '@mews-commander/utils';
import { getServiceSelectedReservationsRateIds } from '../../../../../selectors/summary';
import { NoItems, SummaryRow } from '../../SummaryRow';
import RatesList from './RatesList';

interface StateProps {
    rateIds: string[];
}

interface OwnProps {
    scope: string;
    serviceId: string;
}

type RatesProps = StateProps & OwnProps;

const Rates = ({ rateIds, scope }: RatesProps) => {
    const hasData = notEmpty(rateIds);

    return (
        <SummaryRow label={TextKey.Rate} body={hasData ? <RatesList rateIds={rateIds} scope={scope} /> : <NoItems />} />
    );
};

export default withScopeContext(
    connect<StateProps, null, OwnProps, ApplicationState>(
        createStructuredSelector({
            rateIds: getServiceSelectedReservationsRateIds,
        })
    )(Rates)
);
